
export default {
  assembleDetail: {
    GroupPrice: 'Group Price',
    only: 'people to form a group, only',
    missing: 'people missing to form a group',
    notpaid: 'You havent paid yet, you can open a group after successful payment',
    GroupLeader: 'Group Leader',
    Only: 'Only',
    End: 'End',
    Process: 'Group Process',
    ActivityRules: 'Activity Rules',
    LeaderStarts: 'Leader Starts the group',
    InviteFriends: 'Invite Friends',
    BuyingSuccess: 'Group Buying Success',
    Waitingfor: 'Waiting for shipment',
    ViewMoreGroup: 'View More Group Activities',
    PayNow: 'Pay Now',
    Goto: 'Go to',
    PersonalCenter: 'Personal Center - My Orders',
    orderdetails: 'in order details',
    ViewMyOrders: 'View My Orders',
    InviteFriendsJoin: 'Invite Friends to Join',
    JoinGroup: 'Join Group',
    NewGroup: 'Start a New Group',
    Others: 'Others are joining the group',
    ViewMore: 'View More',
    one: '1. Users participate in group buying activities, become group leaders, and invite others to join the group. If the number of participants reaches the required number within the specified time, the group is successful and waiting for shipment.',
    two: '2. If the number of participants does not reach the required number within the specified time or if the stock is sold out before the group is formed, the group fails, and the order is automatically canceled with a full refund to the original payment account.',
    three: '3. Group buying purchases only support online payment and do not support cash on delivery.',
    four: '4. Cancellation policy: If a group buying order is not successfully paid, and the group has already succeeded or failed, the order will be automatically canceled. Group buying orders cannot be canceled after successful payment. All orders in a failed group will be automatically canceled.',
    five: '5. For some hot-selling products with limited quantities, there may be a limit on the number of group purchases. Please pay attention to the prompt. If there is any violation or participation in promotions through improper means, FAFULI reserves the right to cancel your participation and invalidate related discounts.',
    six: '6. In FAFULI Personal Center - My Group Buying, you can view your own group buying activities.',
    eight: '7. FAFULI reserves the right to interpret the rules of this activity within the limits permitted by law.',
    higher: 'starting from',
    Quantity: 'Quantity',
    Limitedpurchasequantity: 'Limited purchase quantity',
    Confirm: 'Confirm',
    a: 'Oops, this activity has just ended. You can check out other popular activities~',
    b: 'Oops, this activity has been discontinued. You can check out other popular activities~',
    Exceeded: 'Exceeded the limited purchase quantity',
    select: 'Please select a specification!',
    takenoff: 'This product has been taken off the shelf!',
    Only1spot: '【Only 1 spot left】 I',
    yuan: 'yuan, join the group',
    foryou: 'Your friend invited you to join the group, just need you to join!'
  }
}
